export const ShiftDigitalClientId = 'STELLANTIS';

export const ShiftDigitalProviderId = 'CARVANA';
